import React, { useEffect, useRef } from "react";
import { showErrorInNotification } from "../lib/util";
import { CLOUDFARE_TOKEN } from "../config";

const GenerateTurnstileToken = ({ setToken, onError }) => {
  const widgetRef = useRef(null);
  const widgetIdRef = useRef(null);
  const isInitializedRef = useRef(false);

  useEffect(() => {
    // Prevent multiple initializations
    if (isInitializedRef.current) {
      return;
    }

    // Cleanup any existing widget first
    if (widgetIdRef.current && window.turnstile) {
      try {
        window.turnstile.remove(widgetIdRef.current);
      } catch (e) {
        console.log('Error removing existing turnstile widget:', e);
      }
      widgetIdRef.current = null;
    }

    if (window.turnstile && widgetRef.current) {
      try {
        isInitializedRef.current = true;
        widgetIdRef.current = window.turnstile.render(widgetRef.current, {
          sitekey: CLOUDFARE_TOKEN,
          theme: 'light',
          callback: (token) => {
            console.log('Turnstile token generated successfully');
            setToken(token);
          },
          "error-callback": () => {
            console.log('Turnstile error callback triggered');
            showErrorInNotification({
              error_message:
                "CAPTCHA failed to load. Please refresh and try again.",
            });
            // Call the onError prop if provided
            if (onError) {
              onError();
            }
          },
          "expired-callback": () => {
            console.log('Turnstile token expired');
            setToken(null);
            // Call the onError prop if provided
            if (onError) {
              onError();
            }
          },
          "timeout-callback": () => {
            console.log('Turnstile timeout');
            setToken(null);
            // Call the onError prop if provided  
            if (onError) {
              onError();
            }
          }
        });
      } catch (e) {
        console.error('Error rendering turnstile:', e);
        isInitializedRef.current = false;
        if (onError) {
          onError();
        }
      }
    }

    // Cleanup function
    return () => {
      if (widgetIdRef.current && window.turnstile) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch (e) {
          console.log('Error removing turnstile widget on cleanup:', e);
        }
      }
      isInitializedRef.current = false;
    };
  }, []); // Empty dependency array to prevent re-renders
  return <div className="cf-captcha" ref={widgetRef}></div>;
};

export default GenerateTurnstileToken;
